import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-website-dialog',
  templateUrl: './website-dialog.component.html',
  styleUrls: ['./website-dialog.component.scss']
})
export class WebsiteDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
